import React, {Component} from 'react';
import {
  Button,
  TextField,
  Snackbar,
  CircularProgress,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio}
  from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import {axios_instance} from '../../axios_instance';
import { Alert } from "@material-ui/lab";

export default class Workshop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workshops: [],
      is_loading: true,
      careerInfo:[],
      time_out: false,
      is_saved: false,
      enroll_id: '',
      person_id: '',
      person_fname: '',
      person_lastname: '',
      person_idnumber: '',
      person_birthdate: '',
      email: '',
      email_changed: '',
      disabled_save: false,
      snack_open: false,
      snack_message: '',
      snack_alert: 'success'
    }
    this.closeSnack = this.closeSnack.bind(this);
  }
  componentDidMount(){
    console.log('componentDidMount de workshop component');
    axios_instance.get(`/api-preinscript/careers/${this.props.match.params.id}`).then(res=>{
      console.log('encontro la peticion');
      console.log(res);
      this.setState({
        careerInfo: res.data.data,
        is_loading: false
      });
    });
    //aca tiene que mandar una peticion a la api para recuperar los datos de
    //carrera, los talleres recupera despues de buscar los datos del estudiante
    //tiene que tener una validacion de que si el estudiante esta inscripto a la carrera 
    //preguntar si es necesario que paguen para que elijan los talleres, si pagan insertar los carsub_enrolleds
    //si no paga insertar en consults un json o algo
  }
  searchPerson(even) {
    var e = even;
    //funciona pero falta validar error 500
    e.persist();
    if (this.state.person_idnumber != "") {
      this.setState({ time_out: true });
      // setTimeout(() => {
        axios_instance
          .get(
            `/api-preinscript/students-search-congress/${this.props.match.params.id}?filter[person_idnumber]=${this.state.person_idnumber}&all=false`
          )
          .then((res) => {
            if (res.data.data != false) {
              console.log('before rendering');
              console.log(JSON.parse(res.data.data.workshops));
              this.setState({
                enroll_id: res.data.data.enroll_id,
                person_id: res.data.data.person_id,
                person_fname: res.data.data.person_fname,
                person_lastname: res.data.data.person_lastname,
                person_idnumber: res.data.data.person_idnumber,
                person_birthdate: res.data.data.person_birthdate,
                email: res.data.data.email,
                email_changed: res.data.data.email,
                time_out: false,
                is_saved: res.data.data.is_saved,
                workshops: JSON.parse(res.data.data.workshops)
              });
            } else {
              this.setState({
                person_id: '',
                person_fname: '',
                person_lastname: '',
                person_idnumber: '',
                person_birthdate: '',
                email: '',
                email_changed: '',
                is_saved: false,
                time_out: false,
                snack_open: true, 
                snack_alert:'error', 
                snack_message: 'No se ha encontrado ninguna inscripción.'
              })
              /**
               * habra que agregarle un snackbar que indique que no encontro una inscripcion con esa cedula
               */
              //message: 'La búsqueda no encontró una inscripción con esta cédula.'
            }
          });
    //   }, 3000);
  }else{
    this.setState({
      person_id: '',
      person_fname: '',
      person_lastname: '',
      person_idnumber: '',
      person_birthdate: '',
      email: '',
      email_changed: '',
      is_saved: false,
      time_out: false,
      snack_open: true, 
      snack_alert:'error', 
      snack_message: 'Verifique el campo cédula'
    })
  }
  }
  fieldsChange(e) {
    e.preventDefault();
    // console.log(e.target.name);
    this.setState({ [e.target.name]: e.target.value });
  }
  closeSnack() {
    this.setState({ snack_open: false });
  }
  get_day(day){
    let dow = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
    return (dow[day]);
  }
  emailValidated(texto) {
      // Expresión regular para verificar el formato de un correo electrónico
      var patronCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return patronCorreo.test(texto);
  }
  render(){
    var showSnack = '';
    if (this.state.snack_open) {
      showSnack = (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          open={this.state.snack_open}
          autoHideDuration={6000}
          onClose={this.closeSnack}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={this.closeSnack}
            severity={this.state.snack_alert}
          >
            {this.state.snack_message}
          </Alert>
        </Snackbar>
      );
    }
    return(
      <div style={{width: '100%', textAlign: 'center'}}>
        {showSnack}
        {this.state.is_loading ? 
        <div style={{padding:20}}>
          <CircularProgress />
        </div>
        :this.state.careerInfo.tcareer_id === 50002?
          /*en el siguiente div se puede agregar estilos para que sea centrado y ordenar el formulario */
          <div align="center">
            {/*aca se puede agregar la imagen del congreso*/}
            <h3>{this.state.careerInfo.career_name}</h3>
            {/*aca se tiene que agregar la cedula del estudiante para que se haga la busqueda*/}
            <TextField
              id="outlined-basic"
              margin="normal"
              label="Cédula *"
              size="small"
              className="textField-preinscript"
              value={this.state.person_idnumber}
              name="person_idnumber"
              onChange={(event) => (
                this.fieldsChange(event)
                )}
              variant="outlined"
              style={{width: '80%', marginLeft: '10%'}}
              InputProps={{
                endAdornment: (
                  <React.Fragment>
                    {this.state.time_out === true ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                  </React.Fragment>
                ),
              }}
            />
            <Button
              variant="outlined"
              color="primary"
              type="submit"
              onClick={(e)=>{this.searchPerson(e)}}
              style={{width: '80%', marginLeft: '10%', marginTop:20}}
            >
              Buscar
            </Button>
            {this.state.person_id !== '' && 
              (<div>
                <h5>Nombre: {this.state.person_fname} {this.state.person_lastname}</h5>
                {(this.state.email === null || !this.emailValidated(this.state.email)) &&
                  (<TextField
                    variant="outlined"
                    className="textField-preinscript"
                    id="email"
                    name="email"
                    size="small"
                    type={'email'}
                    value={this.state.email_changed}
                    onChange={(e) => {this.setState({ email_changed: e.target.value})}}
                    label='Correo'
                    margin="normal"
                    style={{width: '80%', marginLeft: '10%'}}
                  />)
                }
                <h4 align='center'>Seleccione el seminario o taller en el que desea participar.</h4>
                <ul style={{listStyle: 'none', textAlign: 'left', width: '80%', marginLeft: '10%'}}>
                  {this.state.workshops.map((res, index)=>{
                    return(
                      <li key={index} style={{borderTop: '1px solid gray'}}>
                        <Checkbox
                          disabled={res.cupo > 0 && res.total_inscritos >= res.cupo}
                          checked={res.existe !== null}
                          onChange={()=>{
                            let temp_ws = this.state.workshops;
                            console.log('workshops horario');
                            console.log(temp_ws.find(x=>x.existe !== null));
                            console.log('res.horario');
                            console.log(res.horario);
                            console.log('compara horarios');
                            let hs_condition = false;
                            if(temp_ws.some(x=>x.existe !== null)){
                              hs_condition = res.existe === null && temp_ws.some(x=>x.existe !== null && x.horario.some(obj1 => res.horario.some(obj2 => obj1.day === obj2.day && (obj1.hs_start === obj2.hs_start || obj1.hs_end === obj2.hs_start || obj1.hs_start === obj2.hs_end || obj1.hs_end === obj2.hs_end))));
                            }
                            if(res.existe === null && hs_condition){
                              this.setState({snack_open: true, snack_alert:'error', snack_message: 'Ya has seleccionado un taller para ese horario.'});
                            }else if(res.existe === null){
                              let workshop_limit = this.state.careerInfo.workshop_enroll_limit
                              console.log('careers');
                              console.log(workshop_limit);
                              if(workshop_limit === null || workshop_limit <= 1){
                                temp_ws[index].existe = 1;
                                for(let i=0; i < temp_ws.length; i++){
                                  if(i === index){
                                    temp_ws[i].existe = 1;
                                  }else{
                                    temp_ws[i].existe = null;
                                  }
                                }
                              }else{
                                temp_ws[index].existe = 1;
                                let cont_inscript = 1;
                                for(let i=0; i < temp_ws.length; i++){
                                  if(i === index){
                                    temp_ws[i].existe = 1;
                                  }else if(cont_inscript < workshop_limit && temp_ws[i].existe !== null){
                                    cont_inscript = cont_inscript + 1;
                                    temp_ws[i].existe = 1;
                                  }else{
                                    temp_ws[i].existe = null;
                                  }
                                }
                              }
                            }else{
                              temp_ws[index].existe = null;
                            }
                            this.setState({
                              workshops: temp_ws,
                            })
                          }}
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                        {res.subj_name} {res.cupo > 0 && res.total_inscritos >= res.cupo && ' | Obs: El taller ya no cuenta con cupos disponibles.'}
                        <ul>
                          {res.horario.filter(x=> x.day !== null).map((hs, index_hs)=>(
                            <li key={`${res.carsubj_id} - ${index_hs}`}>
                              {`${this.get_day(hs.day)}, Desde las ${hs.hs_start} hasta las ${hs.hs_end}`}
                            </li>
                          ))}
                        </ul>
                      </li>
                    )
                  })}
                </ul>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<SaveIcon />}
                  type="submit"
                  disabled={this.state.disabled_save}
                  onClick={()=>{
                    if(!this.state.workshops.some(x=> x.existe)){
                      this.setState({snack_open: true, snack_alert:'error', snack_message: 'Seleccione al menos un seminario o taller.'});
                    }else if(this.state.is_saved){
                      this.setState({snack_open: true, snack_alert:'error', snack_message: 'No guardado. Si desea cambiar de seminario o taller, consulte con secretaría.'});
                    }else if(!this.emailValidated(this.state.email_changed)){
                      this.setState({snack_open: true, snack_alert:'error', snack_message: 'Formato de correo electrónico no válido.'});
                    }else if(this.state.workshops.filter(x=> x.existe).length < this.state.careerInfo.workshop_enroll_limit){
                      this.setState({snack_open: true, snack_alert:'error', snack_message: `Debe seleccionar ${this.state.careerInfo.workshop_enroll_limit} talleres con diferentes horarios.`});
                    }else{
                      console.log('depuracion del condicional anterior');
                      console.log('workshop enroll limit', this.state.careerInfo.workshop_enroll_limit);
                      console.log('this.state.workshops.filter(x=> x.existe).length',this.state.workshops.filter(x=> x.existe).length);
                      this.setState({disabled_save: true});
                      axios_instance.post(`/api-preinscript/workshops`, {
                        person_id: this.state.person_id,
                        email: this.state.email_changed,
                        enroll_id: this.state.enroll_id,
                        workshops: this.state.workshops
                      }).then(res=>{
                        setTimeout(()=>{
                          this.setState({disabled_save: false});
                        }, 3000)
                        this.setState({snack_open: true, snack_alert:'success', snack_message: 'Guardado!', is_saved: true});
                      });    
                    }      
                  }}
                  style={{width: '80%', marginLeft: '10%', marginTop:20}}
                >
                  Guardar
                </Button>
              </div>)
            }
          </div>
        :<div align="center">
            No se ha encontrado ningún congreso con la referencia {`${this.props.match.params.id}`}. Verifique el enlace o inténtelo de nuevo más tarde.
          </div>
        }
      </div>
    );
  }
}